import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThirdwebProvider, AutoConnect } from 'thirdweb/react';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import { WalletProvider } from './context/WalletContext';
import WalletGuard from './components/WalletGuard';
import { thirdwebClient, supportedWallets } from './lib/thirdweb';

// Pages
import Dashboard from './pages/Dashboard';
import Strategies from './pages/Strategies';
import VaultPage from './pages/VaultPage';
import Transactions from './pages/Transactions';
import Settings from './pages/Settings';

// Styles
import './styles/global.css';

export default function App() {
  return (
    <HelmetProvider>
      <ThirdwebProvider>
        <AutoConnect client={thirdwebClient} wallets={supportedWallets} timeout={10000} />
        <ThemeProvider>
          <WalletProvider>
            <BrowserRouter>
              <WalletGuard>
                <Routes>
                  <Route path="/" element={<Strategies />} />
                  <Route path="/strategies" element={<Strategies />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/vault/:vaultId" element={<VaultPage />} />
                  <Route path="/transactions" element={<Transactions />} />
                  <Route path="/settings" element={<Settings />} />
                </Routes>
              </WalletGuard>
            </BrowserRouter>
          </WalletProvider>
        </ThemeProvider>
      </ThirdwebProvider>
    </HelmetProvider>
  );
}
